import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-mobile-footer',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterModule],
  templateUrl: './mobile-footer.component.html',
  styleUrl: './mobile-footer.component.scss',
})
export class MobileFooterComponent {
  @Input() visible = false;
  @Input() hasMultipleTenants = false;
  @Input() userName = '';

  @Output() tenantSelected = new EventEmitter<void>();
  @Output() logoutSelected = new EventEmitter<void>();

  profileOpen = false;

  toggleProfile(): void {
    this.profileOpen = !this.profileOpen;
  }
}
